import React from "react";
import ReactDOM from "react-dom";
import { Loader as MLoader } from "monday-ui-react-core";

class Loader extends React.Component
{
    constructor(props)
    {
        super(props);
        
        this.state = {
            counter: 0,
        };
        
        this.loader = React.createRef();
    }
    
    
    showLoader()
    {
        var counter = this.state.counter;
        
        if(counter<0) counter=0;
        
        counter+=1;
        
        this.setState({
            'counter': counter
        });
        this.state.counter = counter;
        //console.log("Loader showLoader counter:", counter);
    }
    
    hideLoader()
    {
        var counter = this.state.counter;
        
        counter-=1;
        
        if(counter<0) counter=0;
        
        this.setState({
            'counter': counter
        });
        this.state.counter = counter;
        //console.log("Loader hideLoader counter:", counter);
    }
    
    
    render()
    {
        var this_component = this;
        //console.log("Loader Render props:", this_component.props);
        /* ( this_component.state.counter>0 ) ? <div ref={this_component.loader} className="monday-loader-wrapper"><img className="monday-loader-img" /></div> : null */
        return (
            <div className="relative myloader" style={this_component.props.style}>
                {
                    ( this_component.state.counter>0 ) ? <div ref={this_component.loader} className="monday-loader-wrapper" style={{ ...{ 'color':'var(--primary-text-color)' }, ...this_component.props.hstyle}}><MLoader size={40} /> Loading data...</div> : null
                }

                {this_component.props.children}
            </div>
        );
    }
}

Loader.defaultProps = {
    'style': {},
    'hstyle': {}
};

export default Loader;
